
<template>
  <v-container
    class="pa-0"
    style="max-width: 900px"
  >
    <v-toolbar
      flat
      color="white"
      class="mb-2"
    >
      <v-btn
        v-if="!$config.isApp"
        icon
        to="/tasklist/index"
      >
        <v-icon>{{ mdiArrowLeft }}</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t('Text.Setting') }}</v-toolbar-title>
    </v-toolbar>

    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          {{ $t('Setting.Sign.Img') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <s-sign-img />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          {{ $t('Setting.Email.Notification') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <s-reminder-email />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          {{ $t('TaskList.DefaultNextStaff') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <s-default-next-staff />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel v-if="isShowPushMsgSetting">
        <v-expansion-panel-header>
          {{ $t('Setting.App.Notification') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <s-app-notification />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>

import SSignImg from './components/Setting/SSignImg'
import SReminderEmail from './components/Setting/SReminderEmail'
import SDefaultNextStaff from './components/Setting/SDefaultNextStaff'
import SAppNotification from './components/Setting/SAppNotification'
import { mdiArrowLeft } from '@mdi/js'
import config from '@/config/config.js'

export default {
  components: {
    SSignImg,
    SReminderEmail,
    SDefaultNextStaff,
    SAppNotification
  },
  data: () => ({
    mdiArrowLeft: mdiArrowLeft,
    isShowPushMsgSetting: config.isShowPushMsgSetting
  })
}
</script>
